<template>
    <v-data-table class="elevation-1"
                  :headers="headers"
                  :items="items"
                  :loading="progress('getAllServices')"
                  hide-default-footer
                  no-data-text="No available services"
                  :items-per-page="-1">
        <template v-slot:item="props">
            <service-item :item="props.item"
                  @click="handleItemClick">
            </service-item>
        </template>
    </v-data-table>
</template>

<script>

    import {mapGetters, mapActions, mapState} from 'vuex'
    import ServiceItem from './ServiceItem';
    export default {
        name: "ServiceList",
        props: {
            items: Array
        },
        components: {
            ServiceItem
        },
        data() {
            return {
                headers: [
                    {
                        text: 'Code',
                        align: 'left',
                        sortable: false,
                        value: 'code'
                    },
                    {
                        text: 'Title',
                        align: 'left',
                        sortable: false,
                        value: 'title'
                    },
                    {
                        text: 'Price',
                        align: 'left',
                        sortable: false,
                        value: 'price'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters('services', {
                progress: 'progress'
            }),
        },
        methods: {
            handleItemClick(item) {
                this.$emit('serviceSelected', item.id)
            }
        }
    }
</script>

<style scoped>

</style>